/* src/app/features/naturezas-juridicas-aceitas/listagem/credito-livre-listagem/credito-livre-listagem.component.scss */
.table-responsive {
  margin-top: 40px;
}
/*# sourceMappingURL=credito-livre-listagem.component.css.map */
